// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Atoms
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Card from 'atoms/Card'
import Spacer from 'atoms/Spacer'

// Icons
import ClearIcon from '@material-ui/icons/Clear'

// Styles
const styles = theme => ({
  root: {
    position: 'relative',
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  content: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'baseline',
    },
  },
  title: {
    minWidth: 200,
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing.unit,
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing.unit,
    },
  },
  children: {
    flex: 1,
  },
  closeButton: {
    position: 'absolute',
    top: -theme.spacing.unit * 3,
    right: -theme.spacing.unit * 3,
    color: theme.palette.primary.main,
  },
  closeButtonIcon: {
    color: theme.palette.primary.contrastText,
    width: theme.spacing.unit * 3,
    height: theme.spacing.unit * 3,
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    padding: theme.spacing.unit / 2,
  }
})

export default
@withStyles(styles)
class ProposalFieldLayout extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    title: PropTypes.any.isRequired,
    children: PropTypes.any,
    onDelete: PropTypes.func,
    extraContent: PropTypes.any,
  }

  render() {
    const { classes, title, children, onDelete, extraContent } = this.props
    return (
      <Card className={classes.root}>
        <div className={classes.content}>
          <Typography variant="body1" className={classes.title}>
            { title }
          </Typography>
          <div className={classes.children}>
            { children }
          </div>
        </div>
        { !!onDelete && (
          <IconButton className={classes.closeButton} onClick={onDelete}>
            <ClearIcon className={classes.closeButtonIcon} />
          </IconButton>
        ) }
        { !!extraContent && (
          <Fragment>
            <Spacer small />
            { extraContent }
          </Fragment>
        ) }
      </Card>
    )
  }
}
